export const ComparablesTypes = {
  COMPANY: 'company',
  MARKET: 'market',
  SECTOR: 'sector',
  MOVERS: 'movers',
} as const
